var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSPeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 10,
    fill: "#22CF4A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4475 33.99C27.8242 34.3667 28.3158 34.5396 28.9225 34.5088C29.5308 34.4771 29.98 34.2625 30.27 33.865L35.0713 27.1662C35.2421 26.9196 35.2275 26.6962 35.0275 26.4962C34.8275 26.2962 34.6037 26.2813 34.3562 26.4513L27.635 31.2312C27.2208 31.5096 26.9879 31.9396 26.9362 32.5213C26.8846 33.1029 27.055 33.5925 27.4475 33.99ZM20.375 38.75C20.1442 38.75 19.9317 38.6912 19.7375 38.5737C19.5425 38.4554 19.3783 38.2946 19.245 38.0912C18.7517 37.2404 18.3792 36.3413 18.1275 35.3938C17.8758 34.4463 17.75 33.4817 17.75 32.5C17.75 30.9433 18.0454 29.4808 18.6363 28.1125C19.2271 26.7442 20.0287 25.5537 21.0412 24.5412C22.0537 23.5287 23.2442 22.7271 24.6125 22.1363C25.9808 21.5454 27.4433 21.25 29 21.25C30.5475 21.25 32.0004 21.5408 33.3588 22.1225C34.7171 22.7033 35.9054 23.495 36.9238 24.4975C37.9429 25.5008 38.7496 26.675 39.3437 28.02C39.9387 29.3658 40.2388 30.8113 40.2438 32.3563C40.2479 33.3929 40.1254 34.3979 39.8763 35.3713C39.6271 36.3454 39.2508 37.2842 38.7475 38.1875C38.6308 38.3908 38.4725 38.5354 38.2725 38.6212C38.0733 38.7071 37.855 38.75 37.6175 38.75H20.375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSPeed);
export default __webpack_public_path__ + "static/media/SPeed.838b1b2a3a0f101e37c3fbe1e5805b79.svg";
export { ForwardRef as ReactComponent };